import { memo } from 'react';
import { ForgotPasswordTemplate } from 'components/templates/ForgotPasswordTemplate';

type Props = {};

export const ForgotPasswordPage = memo((_props: Props) => {
	return <ForgotPasswordTemplate />;
});
